import { useU3403Context } from '../U3403Context';
import { NS } from '../U3403';
import { U3403_LU_CODE, luHandleAppiError } from '../U3403Service';
import U340xKpiStandaloneContainer from '../../u340xKpiShared/components/U340xKpiStandaloneContainer';

function U3403StandaloneScreen() {
  const { initLU } = useU3403Context();

  return (
    <U340xKpiStandaloneContainer
      logicalUnitCode={U3403_LU_CODE}
      nameSpace={NS}
      initLU={initLU}
      luHandleAppiError={luHandleAppiError}
    />
  );
}

export default U3403StandaloneScreen;
